import React, {useState} from "react";
import {IonButton, IonButtons, IonIcon, IonInput, IonItem, IonLabel} from "@ionic/react";
import {checkmark, closeOutline} from "ionicons/icons";
import {useAppDispatch} from "../../../lib/hooks";
import {actions} from "../../../lib/app";


interface ItemRebanho {
  num_animais: number;
  nome: string;
  peso_medio: number;
}


interface RebanhoEditProps {
  instance: ItemRebanho;
  setValue: (values: ItemRebanho) => void;
  setCloseEdit: () => void;
}


const RebanhoEdit: React.FC<RebanhoEditProps> = (props) => {
  const {instance} = props;
  const dispatch = useAppDispatch();

  const [nome, setNome] = useState(instance.nome);
  const [numAnimais, setNumAnimais] = useState(instance.num_animais);
  const [pesoMedio, setPesoMedio] = useState(instance.peso_medio);

  const setValues = () => {
    // validar
    if (!nome)
      return dispatch(actions.notifyError('A descrição deve ser preenchida.'));
    if (!pesoMedio)
      return dispatch(actions.notifyError('O peso médio deve ser preenchido.'));

    props.setValue({
      ...instance,
      nome,
      peso_medio: pesoMedio,
      num_animais: numAnimais,
    });
    props.setCloseEdit();
  }

  return (
    <>
      <IonItem>
        <IonLabel position="floating">
          Descrição
        </IonLabel>
        <IonInput
          value={nome}
          onIonChange={e => setNome(e.detail.value || '')}
        />
      </IonItem>

      <IonItem>
        <IonLabel position="floating">
          Cabeças
        </IonLabel>
        <IonInput
          inputMode={'numeric'}
          value={numAnimais}
          onIonChange={e => setNumAnimais(Number.parseInt(e.detail.value || '0'))}
        />
      </IonItem>

      <IonItem>
        <IonLabel position="floating">
          Peso médio (Kg)
        </IonLabel>
        <IonInput
          inputMode={'numeric'}
          value={pesoMedio}
          onIonChange={e => setPesoMedio(Number.parseInt(e.detail.value || '0'))}
        />
      </IonItem>

      <div className="flex justify-end mt-6">
        <IonButtons>
          <IonButton
            onClick={setValues}
          >
            <IonIcon
              icon={checkmark}
            />
          </IonButton>
          <IonButton
            onClick={() => props.setCloseEdit()}
          >
            <IonIcon
              icon={closeOutline}
            />
          </IonButton>
        </IonButtons>
      </div>
    </>
  )
};

export default RebanhoEdit;
